module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[87]86.c2269be.woff2";